import type { CriterionLocaleBundle } from '../localize'

/** Unofficial translations from docs/kata — English scoring text remains authoritative. */
export const itsutsuNoKataCriteriaI18n: CriterionLocaleBundle = {
  "ja": {
    "itsutsu-gen-bow-side": {
      "text": "礼の際、取は審判の右側、受は左側に位置する。"
    },
    "itsutsu-gen-uke-advance": {
      "text": "移動：礼と形の開始動作の後、受は左足から歩み足（ayumi-ashi）で中央へ進み、自然本体（shizen-hontai）になる。"
    },
    "itsutsu-gen-tori-approach": {
      "text": "取は左足からゆっくり歩み足で受に近づきながら、右の手のひらを前に向けて右前腕をゆっくり上げる。"
    },
    "itsutsu-gen-toe-position": {
      "text": "取は受のやや右側に立ち、右足の小指を受の右足の小指の横に置き、右肩が受の肩にほぼ触れる位置を取る。"
    },
    "itsutsu-gen-palm-chest": {
      "text": "取は指を伸ばした右の手のひらを受の胸の中央に当てる。"
    },
    "itsutsu-form-1-1": {
      "text": "取は右手で受を後方へ押し、小指側と親指側の押しを交互に行う。小指側から始める。"
    },
    "itsutsu-form-1-2": {
      "text": "受は左足から小刻みに後退する。"
    },
    "itsutsu-form-1-3": {
      "text": "取は右手で受の胸を押しながら、右足、左足の順に前進する。"
    },
    "itsutsu-form-1-4": {
      "text": "取は右足を踏み出し、受を強く押して均衡を崩し、倒す。"
    },
    "itsutsu-form-1-5": {
      "text": "受は両足を畳につけたまま背中を反らせて後方に倒れる。両足の間隔はほぼ肩幅とする。"
    },
    "itsutsu-form-2-1": {
      "text": "一本目の後、取は右足を引いて自然本体になる。"
    },
    "itsutsu-form-2-2": {
      "text": "受は右膝を畳につけ、左膝を立てて起き上がる。"
    },
    "itsutsu-form-2-3": {
      "text": "受は立ち上がり、右手を腰の位置で手刀（te-gatana）にし、指先を取に向け、親指を上にする。"
    },
    "itsutsu-form-2-4": {
      "text": "受は右足を大きく踏み出し、右手で取の腹部中央を攻撃する。"
    },
    "itsutsu-form-2-5": {
      "text": "取は左足を引いて左に転じ、左手で受の右手首を、右手で受の肘の内側をつかむ。親指は上に向ける。"
    },
    "itsutsu-form-2-6": {
      "text": "取は左膝を畳につきながら、両手で受を引き下ろす。"
    },
    "itsutsu-form-2-7": {
      "text": "受は前方へ進みながら横方向の受身を取る。"
    },
    "itsutsu-form-3-1": {
      "text": "取と受は左膝を畳につけ、鳳凰が翼を広げるように両腕を伸ばし、やや前傾して立ち上がる。手のひらは前に向け、指は自然に伸ばす。"
    },
    "itsutsu-form-3-2": {
      "text": "取と受は反時計回りに回り、互いに近づく。"
    },
    "itsutsu-form-3-3": {
      "text": "取と受は中央で向かい合い、正面（Shomen）は取の左側に位置する。"
    },
    "itsutsu-form-3-4": {
      "text": "取と受は腕を交差させ、左腕を上にする。"
    },
    "itsutsu-form-3-5": {
      "text": "取と受は右腕を上げ、左腕を下に押す。"
    },
    "itsutsu-form-3-6": {
      "text": "取と受は徐々に速度を上げながら反時計回りに回る。"
    },
    "itsutsu-form-3-7": {
      "text": "取は右前隅に位置したところで仰向けに滑り込み、両足を受の右足の外側へ滑らせ、受を自分の体の上を越えて右前方の正面方向へ投げる。"
    },
    "itsutsu-form-3-8": {
      "text": "受は取の体を斜めに越えて受身を取り、自然本体で立ち上がる。"
    },
    "itsutsu-form-4-1": {
      "text": "取は受と 7 m の間隔で向かい合い、自然本体で立つ。"
    },
    "itsutsu-form-4-2": {
      "text": "取は左足を引き、両腕を前方から左側、後方へ移しながら重心を下げる。"
    },
    "itsutsu-form-4-3": {
      "text": "取は両腕を再び前方へ振り出す。"
    },
    "itsutsu-form-4-4": {
      "text": "取は徐々に速度を上げながら歩み足で受に向かって進む。"
    },
    "itsutsu-form-4-5": {
      "text": "取は受の位置を約 1 m 通り越し、手のひらを前に向けて両腕を上げ、踵を畳から浮かせてつま先立ちになる。"
    },
    "itsutsu-form-4-6": {
      "text": "取は深呼吸した後、手のひらを下にして両腕を左右に広げ、踵を畳につける。"
    },
    "itsutsu-form-4-7": {
      "text": "取は右足から 2～3 歩後退し、右肘を受の胸に当てて均衡を崩す。"
    },
    "itsutsu-form-4-8": {
      "text": "受はゆっくり後退し、徐々に速度を上げる。"
    },
    "itsutsu-form-4-9": {
      "text": "受が均衡を保てなくなると、取は左膝を畳につき、受を後方へ押し倒す。受は受身を取る。"
    },
    "itsutsu-form-4-10": {
      "text": "受は崩れに従って数歩移動した後、後方へ倒れる。"
    },
    "itsutsu-form-5-1": {
      "text": "取は正面の左側、受は右側に位置し、約 8 m 離れる。"
    },
    "itsutsu-form-5-2": {
      "text": "取と受は自然本体で立ち、右足を踏み出して自護体（jigo-tai）となり、両腕を広げる。"
    },
    "itsutsu-form-5-3": {
      "text": "取と受は左足を軸に回り、互いに向かい合う。"
    },
    "itsutsu-form-5-4": {
      "text": "深呼吸した後、取と受は右足から走り出し、徐々に速度を上げて互いに向かう。"
    },
    "itsutsu-form-5-5": {
      "text": "衝突する直前、取は正面に対して直角になるよう左側へ滑り込んで倒れる。左足、右足の順に受の右足の外側へ滑らせ、両手を下腹部に置く。"
    },
    "itsutsu-form-5-6": {
      "text": "受は取の体を越えて正面の左側へ受身を取り、畳の上に立つ。"
    }
  },
  "zh-Hant": {
    "itsutsu-gen-bow-side": {
      "text": "行禮時，取位於裁判的右方，受位於左方。"
    },
    "itsutsu-gen-uke-advance": {
      "text": "移動：行禮並完成形的開始動作後，受從左腳起，以步足（ayumi-ashi）前進至中央，採自然本體（shizen-hontai）。"
    },
    "itsutsu-gen-tori-approach": {
      "text": "取從左腳起，以步足緩慢走向受，同時緩慢抬起右前臂，右掌朝前。"
    },
    "itsutsu-gen-toe-position": {
      "text": "取站在受稍偏右的位置，右腳小趾靠近受的右腳小趾，右肩幾乎接觸受的肩膀。"
    },
    "itsutsu-gen-palm-chest": {
      "text": "取將右掌放在受的胸部中央，手指伸直。"
    },
    "itsutsu-form-1-1": {
      "text": "取以右手將受向後推，小指側與拇指側交替施壓，先從小指側開始。"
    },
    "itsutsu-form-1-2": {
      "text": "受從左腳起，以小步向後退。"
    },
    "itsutsu-form-1-3": {
      "text": "取先進右腳、再進左腳，同時以右手推受的胸部。"
    },
    "itsutsu-form-1-4": {
      "text": "取右腳向前踏出，用力推受，使其失去平衡並倒下。"
    },
    "itsutsu-form-1-5": {
      "text": "受向後仰倒，雙腳保持接觸地面，背部拱起；雙腳在地面上的間距約與肩同寬。"
    },
    "itsutsu-form-2-1": {
      "text": "一本目結束後，取右腳後退，採自然本體。"
    },
    "itsutsu-form-2-2": {
      "text": "受起身時，右膝著地，左膝立起。"
    },
    "itsutsu-form-2-3": {
      "text": "受站起，右手在腰側作手刀（te-gatana），手指指向取，拇指朝上。"
    },
    "itsutsu-form-2-4": {
      "text": "受右腳大步向前，以右手攻擊取的腹部中央。"
    },
    "itsutsu-form-2-5": {
      "text": "取左腳後退並向左轉身，以左手握受的右手腕，右手握其肘部內側，拇指朝上。"
    },
    "itsutsu-form-2-6": {
      "text": "取左膝落地，同時以雙手將受向下拉。"
    },
    "itsutsu-form-2-7": {
      "text": "受向前作側向受身。"
    },
    "itsutsu-form-3-1": {
      "text": "取與受左膝著地，雙臂如鳳凰展翼般伸開，上身稍向前傾而站起；掌心朝前，手指自然伸展。"
    },
    "itsutsu-form-3-2": {
      "text": "取與受逆時針轉動，逐漸接近對方。"
    },
    "itsutsu-form-3-3": {
      "text": "取與受在中央相對，正面位於取的左側。"
    },
    "itsutsu-form-3-4": {
      "text": "取與受的手臂交叉，左臂在上。"
    },
    "itsutsu-form-3-5": {
      "text": "取與受抬起右臂，將左臂向下壓。"
    },
    "itsutsu-form-3-6": {
      "text": "取與受逆時針轉動，逐漸加速。"
    },
    "itsutsu-form-3-7": {
      "text": "取在右前方的位置仰身滑落地面，雙腳滑至受右腳的外側，使受越過自己的身體，向右前方、即正面方向被摔出。"
    },
    "itsutsu-form-3-8": {
      "text": "受斜向越過取的身體作受身，然後以自然本體站起。"
    },
    "itsutsu-form-4-1": {
      "text": "取以自然本體面向受，兩者相距 7 米。"
    },
    "itsutsu-form-4-2": {
      "text": "取左腳後退，降低重心，雙臂由前方移至左側及後方。"
    },
    "itsutsu-form-4-3": {
      "text": "取將雙臂向前擺回。"
    },
    "itsutsu-form-4-4": {
      "text": "取以步足走向受，逐漸加速。"
    },
    "itsutsu-form-4-5": {
      "text": "取越過受的位置約 1 米，抬起雙臂，掌心朝前，踮腳站立，腳跟離開榻榻米。"
    },
    "itsutsu-form-4-6": {
      "text": "取深呼吸後，雙臂向兩側伸展，掌心朝下，腳跟落地。"
    },
    "itsutsu-form-4-7": {
      "text": "取從右腳起後退 2–3 步，將右肘放在受的胸部，使其失去平衡。"
    },
    "itsutsu-form-4-8": {
      "text": "受緩慢後退，逐漸加速。"
    },
    "itsutsu-form-4-9": {
      "text": "當受無法維持平衡時，取左膝著地，推受向後仰倒，受作受身。"
    },
    "itsutsu-form-4-10": {
      "text": "受隨失衡再退數步，然後向後倒下。"
    },
    "itsutsu-form-5-1": {
      "text": "取位於正面的左方，受位於右方，兩者相距約 8 米。"
    },
    "itsutsu-form-5-2": {
      "text": "取與受先採自然本體，然後右腳向前踏出，採自護體（jigo-tai），雙臂伸開。"
    },
    "itsutsu-form-5-3": {
      "text": "取與受以左腳為軸轉身，面向對方。"
    },
    "itsutsu-form-5-4": {
      "text": "深呼吸後，取與受從右腳起，向對方跑去，逐漸加速。"
    },
    "itsutsu-form-5-5": {
      "text": "即將相撞前，取以左側身滑落地面，身體與正面方向垂直；先滑左腳，再將右腳滑至受右腳外側，雙手置於下腹部。"
    },
    "itsutsu-form-5-6": {
      "text": "受越過取的身體，向正面的左方作受身，然後站在榻榻米上。"
    }
  }
}
